import React from 'react';
import { Title } from './Title/Title';
import { st, classes } from './Header.st.css';

export const Header = () => {
  return (
    <div className={st(classes.root)}>
      <Title />
    </div>
  );
};
